/** `commissions.run.run_month` is the calendar month of qualifying customer payments. */

export function commissionRunMonthKey(runMonthIso: string): string {
  const match = /^(\d{4}-\d{2})/.exec(runMonthIso.trim());
  return match?.[1] ?? runMonthIso.slice(0, 7);
}

export function formatCommissionRunMonthLong(runMonthIso: string): string {
  const match = /^(\d{4})-(\d{2})/.exec(runMonthIso.trim());
  if (match == null) {
    return runMonthIso;
  }
  const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 1));
  return date.toLocaleDateString("en-US", { month: "long", year: "numeric", timeZone: "UTC" });
}

/** Page title and breadcrumb for a payment month (e.g. "August 2026"). */
export function commissionRunTitle(runMonthIso: string): string {
  return formatCommissionRunMonthLong(runMonthIso);
}

/** Latest payment-month run that is open for review (prior complete calendar month). */
export function currentOpenCommissionRunMonthKey(referenceDate = new Date()): string {
  const year = referenceDate.getUTCFullYear();
  const month = referenceDate.getUTCMonth();
  const prior = new Date(Date.UTC(year, month - 1, 1));
  return prior.toISOString().slice(0, 7);
}
